const styles = {
  rowStyles: {
    marginBottom: 8,
    display: 'block'
  }
}
export { styles }
